import { render, staticRenderFns } from "./PsPatientDiseases.vue?vue&type=template&id=2def87c7&scoped=true&"
import script from "./PsPatientDiseases.vue?vue&type=script&lang=js&"
export * from "./PsPatientDiseases.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientDiseases.vue?vue&type=style&index=0&id=2def87c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def87c7",
  null
  
)

export default component.exports